import React from 'react';
import './CounterMenuLayersOverlay.scss'
const CounterMenuLayersOverlay = ({active}) => {

    return (
        <div className={active ? 'counter-menu-layers-overlay' : ''}/>
    );
}
export default CounterMenuLayersOverlay;